import { Component, OnInit } from '@angular/core';
import { SeoService } from 'src/app/services/seo.service';


@Component({
  selector: 'app-order-confirmed',
  templateUrl: './order-confirmed.page.html',
  styleUrls: ['./order-confirmed.page.scss'],
})
export class OrderConfirmedPage implements OnInit {
  image = '../../../assets/icon/confirmed.svg';
  isAsp = false;

  constructor(private seoService: SeoService) {
    this.seoService.updatePageTitle('order-confirmed');
    if (localStorage.getItem("pid") == "asp") {
      this.isAsp = true;
    }
  }

  ngOnInit() {
  }

}
